import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import IconButton from "../../IconButton/IconButton";
import styles from "../TransparentDrawer.module.scss";
import useOnClickFunctions from "../helpers/onClickFunctions";
import { useParams } from "react-router-dom";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";

function SplitTheBill() {
  const { t } = useTranslation();
  const { handleNavigate, handleClose } = useOnClickFunctions();
  const { restaurantId, tableId } = useParams();
  const { remainingGuests = [] } = useVenuesDataStore();

  return (
    <div className={styles.paymentButtonsGroupWrapper}>
      <div className={styles.paymentButtonsGroupHeader}>
        <IconButton
          iconName="las la-angle-left icon-big"
          onClick={() =>
            handleNavigate(
              `/restaurants/${restaurantId}/tables/${tableId}/pay-your-bill`,
            )
          }
          color="primary"
        />
        <p className={`body-bold-large ${styles.paymentButtonsGroupTitle}`}>
          {t("transparentDrawer.title.splitTheBill")}
        </p>
        <IconButton
          iconName="las la-times icon-big"
          onClick={() => handleClose()}
          color="primary"
        />
      </div>
      {remainingGuests.length > 0 && (
        <Button
          onClick={() => {
            handleNavigate(
              `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/pay-for-your-items`,
            );
          }}
          label={t("transparentDrawer.button.payForYourItems")}
          variant="contained"
          color="primary"
          maxWidth
          mobile={true}
          icon="las la-list-ul icon-medium"
        />
      )}
      <Button
        onClick={() =>
          handleNavigate(
            `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/equally`,
          )
        }
        label={t("transparentDrawer.button.divideBillEqually")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
        icon="las la-chart-pie icon-medium"
      />
      <Button
        onClick={() =>
          handleNavigate(
            `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill/custom`,
          )
        }
        label={t("transparentDrawer.button.payACustomAmount")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
        icon="las la-pen icon-medium"
      />
    </div>
  );
}

export default SplitTheBill;
